import * as Yup from 'yup';
import { find } from 'lodash';

import { Nullable } from '~globals/types/commons';
import { VALIDATIONS_ERROR } from '~constants/index';
import { DriverCompanyBase } from '~services/driver/types';

export const FIELDS_NAME = {
  CURRENT_DRIVER: 'currentDriver',
} as const;

export const initialValues = {
  [FIELDS_NAME.CURRENT_DRIVER]: null as Nullable<DriverCompanyBase>,
};

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.CURRENT_DRIVER]: Yup.mixed().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
});

export const findSelectedDriver = (
  drivers: DriverCompanyBase[],
  selectedDriverId: string,
): DriverCompanyBase | undefined => find(drivers, { id: selectedDriverId });

export const getDriverNotAvailable = (
  currentDriver: DriverCompanyBase,
  forceAvailable?: boolean,
): boolean => {
  if (forceAvailable) return false;

  return !currentDriver.isAvailable;
};
